import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "titled-value" }
const _hoisted_2 = { class: "titled-value__title" }

import { PropType, Component } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'VTitledValue',
  props: {
    title: { type: String, default: '' },
    value: { type: [String, Number], default: '' },
    warning: { type: Boolean, default: false },
    success: { type: Boolean, default: false },
    negative: { type: Boolean, default: false },
    icon: { type: Object as PropType<Component | null>, default: null },
},
  setup(__props) {

// Other
const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("small", _hoisted_2, _toDisplayString(props.title), 1),
    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("span", {
      class: _normalizeClass(["titled-value__value text text--blurry", {
                'text--warning': props.warning,
                'text--success': props.success,
                'text--negative': props.negative,
            }])
    }, [
      _createElementVNode("b", null, _toDisplayString(props.value), 1),
      (_openBlock(), _createBlock(_resolveDynamicComponent(props.icon), { class: "titled-value__value-icon svg svg--100" }))
    ], 2)
  ]))
}
}

})